declare let __APP_ENV__: string;

export const useAppEnvironment = () => {
  return __APP_ENV__;
};

export default useAppEnvironment;
